@if (isTreeTableRowHost()) {
	@if (multiSelect) {
		<td
			role="gridcell"
			class="library-tree-cell library-tree-cell-select"
			data-tree-cell="select"
			[attr.headers]="treeGridSelectHeaderId"
			(focusin)="emitTreeGridFocus('select')"
			(keydown)="emitTreeGridKeydown($event, 'select')">
			<mat-checkbox
				color="primary"
				[tabIndex]="treeGridCheckboxTabindex"
				(click)="$event.stopPropagation()"
				[checked]="node.checked"
				(change)="onCheckboxChange($event.checked)"
				[aria-label]="
					(node.checked
						? 'library-collections_multi-deselect-one'
						: 'library-collections_multi-select-one'
					) | translate : { item: collectionItem.name }">
			</mat-checkbox>
		</td>
	}
	<th
		scope="row"
		role="rowheader"
		class="library-tree-cell library-tree-cell-name"
		data-tree-cell="name"
		[attr.headers]="treeGridNameHeaderId"
		[attr.aria-labelledby]="getTreeGridNameLabelledBy()"
		[attr.tabindex]="treeGridNameTabindex"
		(focus)="emitTreeGridFocus('name')"
		(keydown)="emitTreeGridKeydown($event, 'name')"
		data-cy="library-item-row">
		<div
			[attr.data-tree-node-key]="null"
			(click)="loadItemDetails('expandItem', collectionItem)"
			class="library-item-info"
			[class.library-item-info--multi-select]="multiSelect"
			[class.withMargin]="false"
			data-cy="library-item-details">
			@if (!multiSelect) {
				<i
					class="library-item-icon"
					[ngClass]="iconClass"
				></i>
			}

			<span class="collection-item-name" data-cy="collection-item-name" [id]="getTreeGridNameElementId()">
				{{ collectionItem.name || "common_untitled" | translate }}
			</span>
		</div>
	</th>
	<td
		role="gridcell"
		class="library-tree-cell library-tree-cell-modified"
		data-tree-cell="modified"
		[attr.headers]="treeGridModifiedHeaderId"
		[attr.aria-labelledby]="getTreeGridModifiedLabelledBy()"
		[attr.tabindex]="treeGridModifiedTabindex"
		(focus)="emitTreeGridFocus('modified')"
		(keydown)="emitTreeGridKeydown($event, 'modified')"
		(click)="loadItemDetails('expandItem', collectionItem)">
		<span class="collection-item-modified-date" [id]="getTreeGridModifiedElementId()">
			{{ formatDate(collectionItem.modified_at) }}
		</span>
	</td>
	<td role="gridcell" class="library-tree-cell library-tree-cell-actions">
		@if (!multiSelect) {
			<button
				[matMenuTriggerFor]="rowMenu"
				data-tree-row-action
				data-tree-cell="actions"
				[attr.tabindex]="treeGridActionTabindex"
				class="menu-btn collection-item-menu item-options-dropdown-menu btn-none"
				data-cy="library-item-dropdown-menu"
				[attr.aria-label]="getMenuAriaLabel()"
				(focus)="emitTreeGridFocus('actions')"
				(keydown)="emitTreeGridKeydown($event, 'actions')"
				(click)="setActiveToggle($event); $event.stopPropagation()"
				>
				<i class="ficon-app-dots-vertical"></i>
			</button>
			<mat-menu #rowMenu="matMenu" class="collection-item-dropdown-menu">
				@if (displayMenuOptions | async) {
					<button
						mat-menu-item
						data-cy="common-preview"
						class="preview-option"
						(click)="loadItemDetails('previewItem', collectionItem)"
						>
						<span>{{ "common_preview" | translate }}</span>
					</button>
					@if (shouldShowEdit()) {
						<button
							mat-menu-item
							data-cy="edit-library-item-button"
							class="edit-option"
							(click)="loadItemDetails('edit', collectionItem)"
							>
							<span>{{ "common_edit" | translate }}</span>
						</button>
					}
					<button
						mat-menu-item
						data-cy="common_copy"
						class="copy-option"
						(click)="copyItem(collectionItem)"
						>
						<span>{{ "common_copy" | translate }}</span>
					</button>
					@if (canMove(collectionItem)) {
						<button
							mat-menu-item
							data-cy="common-move"
							class="move-option"
							(click)="moveItem(collectionItem)"
							>
							<span>{{ "common_move" | translate }}</span>
						</button>
					}
					@if (canShare()) {
						<button
							mat-menu-item
							class="share-option"
							(click)="loadItemDetails('shareItem', collectionItem)"
							>
							<span>{{ "common_share" | translate }}</span>
						</button>
					}
					@if (canRemove(collectionItem)) {
						<button
							mat-menu-item
							data-cy="common-remove"
							class="remove-option"
							(click)="removeItem(collectionItem)"
							>
							<span>{{ "common_remove" | translate }}</span>
						</button>
					}
					@if (shouldShowDownloadButton(collectionItem)) {
						<button
							mat-menu-item
							data-cy="download-library-item"
							class="download-option"
							(click)="downloadItem(collectionItem)"
							>
							<span>{{ "common_download" | translate }}</span>
						</button>
					}
					@if (canRestore(collectionItem)) {
						<button
							mat-menu-item
							class="restore-option"
							(click)="moveItem(collectionItem)"
							>
							<span>{{ "common_restore" | translate }}</span>
						</button>
					}
					@if (!UADetect.isMobile() && itemInUse) {
						<button
							mat-menu-item
							class="download-report-option"
							(click)="downloadReport(collectionItem)"
							>
							<span>{{ "library-collections_download-report" | translate }}</span>
						</button>
					}
				} @else {
					<div class="loading-items">
						<i class="ficon-spinner ficon-spin"></i>
					</div>
				}
			</mat-menu>
		}
	</td>
} @else if (treeTableDetailView) {
	<div class="library-item-expanded library-item-expanded--tree-table">
		<div class="library-item-details" tabindex="0">
			<div class="library-item-details-row title-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-name"
				></span>
				<span>{{ collectionItem.name || "common_untitled" | translate }}</span>
			</div>
			<div class="library-item-details-row mobile-only">
				<span
					class="library-item-details-title"
					translate="library-collections_details-last-modified"
				></span>
				<span>{{ formatDate(collectionItem.modified_at) }}</span>
			</div>
			@if (collectionItem.location) {
				<div class="library-item-details-row location-row">
					<span
						class="library-item-details-title"
						translate="library-collections_details-location"
					></span>
					<span>{{ collectionItem.location }}</span>
				</div>
			}
			<div class="library-item-details-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-creator"
				></span>
				<span>{{ collectionItem.creator_name }}</span>
			</div>
			<div class="library-item-details-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-creation-date"
				></span>
				<span>{{ formatDate(collectionItem.item.created_at) }}</span>
			</div>
			<div class="library-item-details-row description-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-description"
				></span>
				<span class="library-item-description">{{ collectionItem.description }}</span>
			</div>
		</div>
		@if (collectionItem.collection_item_type === 'media' && media) {
			<ngx-media-thumbnail
				class="media-thumbnail"
				[media]="media"
			></ngx-media-thumbnail>
		}
		<div class="library-item-buttons">
			@if (shouldShowEdit()) {
				<button
					type="button"
					class="tertiary-btn edit-btn"
					data-cy="expanded-item-edit-btn"
					(click)="loadItemDetails('edit', collectionItem)"
					>
					<span translate="common_edit"></span>
				</button>
			}
			@if (showPreviewButton(collectionItem)) {
				<button
					type="button"
					class="secondary-btn preview-btn"
					data-cy="library-item-preview-button"
					(click)="loadItemDetails('previewItem', collectionItem)"
					>
					<span translate="library-collections_details-preview"></span>
				</button>
			}
			@if (mode === modes.SELECT) {
				<button
					data-cy="library-item-select"
					type="submit"
					class="primary-btn submit-btn"
					(click)="selectItem.emit({item: collectionItem})"
					>
					<span translate="library-collections_details-select"></span>
				</button>
			}
		</div>
	</div>
} @else {
	<div
		class="library-item-row"
		[class.active]="isActive()"
		data-cy="library-item-row"
		[attr.data-node-level]="nodeLevel"
		[style.--node-level]="nodeLevel">
		<span
			[attr.aria-label]="getAriaLabel(collectionItem)"
			[attr.data-tree-node-key]="null"
			(click)="loadItemDetails('expandItem', collectionItem)"
			tabindex="0"
			(keyup.enter)="loadItemDetails('expandItem', collectionItem)"
			[attr.aria-expanded]="isItemExpanded()"
			class="library-item-info"
			[class.withMargin]="multiSelect"
			data-cy="library-item-details"
			>
			@if (!multiSelect) {
				<i
					class="library-item-icon"
					[ngClass]="iconClass"
				></i>
			}
			@if (multiSelect) {
				<mat-checkbox
					color="primary"
					(click)="$event.stopPropagation()"
					[checked]="collectionItem.checked"
					[(ngModel)]="collectionItem.checked"
					(change)="checkSelection()"
					[aria-label]="
						(collectionItem.checked
							? 'library-collections_multi-deselect-one'
							: 'library-collections_multi-select-one'
						) | translate : { item: collectionItem.name }">
				</mat-checkbox>
			}

			<span class="collection-item-name" data-cy="collection-item-name">
				{{ collectionItem.name || "common_untitled" | translate }}
			</span>
			<span class="collection-item-modified-date">
				{{ formatDate(collectionItem.modified_at) }}
			</span>
		</span>
		@if (!multiSelect) {
			<button
				[matMenuTriggerFor]="menu"
				class="menu-btn collection-item-menu item-options-dropdown-menu btn-none"
				data-cy="library-item-dropdown-menu"
				[attr.aria-label]="getMenuAriaLabel()"
				(click)="setActiveToggle($event)"
				>
				<i class="ficon-app-dots-vertical"></i>
			</button>
		}
		@if (isLoadingDetailsForItem | async) {
			<div class="loading-indicator-row">
				<mat-progress-bar [attr.aria-label]="'common_loading'| translate" mode="indeterminate"></mat-progress-bar>
			</div>
		}
	</div>

		@if (isItemExpanded() && (isLoadingDetailsForItem | async) === false) {
		<div class="library-item-expanded">
			<div class="library-item-details" tabindex="0">
				<div class="library-item-details-row title-row">
					<span
						class="library-item-details-title"
						translate="library-collections_details-name"
					></span>
					<span>{{ collectionItem.name || "common_untitled" | translate }}</span>
				</div>
				<div class="library-item-details-row mobile-only">
					<span
						class="library-item-details-title"
						translate="library-collections_details-last-modified"
					></span>
					<span>{{ formatDate(collectionItem.modified_at) }}</span>
				</div>
				@if (collectionItem.location) {
					<div class="library-item-details-row location-row">
						<span
							class="library-item-details-title"
							translate="library-collections_details-location"
						></span>
						<span>{{ collectionItem.location }}</span>
					</div>
				}
				<div class="library-item-details-row">
					<span
						class="library-item-details-title"
						translate="library-collections_details-creator"
					></span>
					<span>{{ collectionItem.creator_name }}</span>
				</div>
				<div class="library-item-details-row">
					<span
						class="library-item-details-title"
						translate="library-collections_details-creation-date"
					></span>
					<span>{{ formatDate(collectionItem.item.created_at) }}</span>
				</div>
				<div class="library-item-details-row description-row">
					<span
						class="library-item-details-title"
						translate="library-collections_details-description"
					></span>
					<span class="library-item-description">{{ collectionItem.description }}</span>
				</div>
			</div>
			@if (collectionItem.collection_item_type === 'media' && media) {
				<ngx-media-thumbnail
					class="media-thumbnail"
					[media]="media"
				></ngx-media-thumbnail>
			}
			<div class="library-item-buttons">
				@if (shouldShowEdit()) {
					<button
						type="button"
						class="tertiary-btn edit-btn"
						data-cy="expanded-item-edit-btn"
						(click)="loadItemDetails('edit', collectionItem)"
						>
						<span translate="common_edit"></span>
					</button>
				}
				@if (showPreviewButton(collectionItem)) {
					<button
						type="button"
						class="secondary-btn preview-btn"
						data-cy="library-item-preview-button"
						(click)="loadItemDetails('previewItem', collectionItem)"
						>
						<span translate="library-collections_details-preview"></span>
					</button>
				}
				@if (mode === modes.SELECT) {
					<button
						data-cy="library-item-select"
						type="submit"
						class="primary-btn submit-btn"
						(click)="selectItem.emit({item: collectionItem})"
						>
						<span translate="library-collections_details-select"></span>
					</button>
				}
			</div>
			</div>
		}

		<mat-menu #menu="matMenu" class="collection-item-dropdown-menu">
			@if (displayMenuOptions | async) {
				<button
					mat-menu-item
					data-cy="common-preview"
					class="preview-option"
					(click)="loadItemDetails('previewItem', collectionItem)"
					>
					<span>{{ "common_preview" | translate }}</span>
				</button>
				@if (shouldShowEdit()) {
					<button
						mat-menu-item
						data-cy="edit-library-item-button"
						class="edit-option"
						(click)="loadItemDetails('edit', collectionItem)"
						>
						<span>{{ "common_edit" | translate }}</span>
					</button>
				}
				<button
					mat-menu-item
					data-cy="common_copy"
					class="copy-option"
					(click)="copyItem(collectionItem)"
					>
					<span>{{ "common_copy" | translate }}</span>
				</button>
				@if (canMove(collectionItem)) {
					<button
						mat-menu-item
						data-cy="common-move"
						class="move-option"
						(click)="moveItem(collectionItem)"
						>
						<span>{{ "common_move" | translate }}</span>
					</button>
				}
				@if (canShare()) {
					<button
						mat-menu-item
						class="share-option"
						(click)="loadItemDetails('shareItem', collectionItem)"
						>
						<span>{{ "common_share" | translate }}</span>
					</button>
				}
				@if (canRemove(collectionItem)) {
					<button
						mat-menu-item
						data-cy="common-remove"
						class="remove-option"
						(click)="removeItem(collectionItem)"
						>
						<span>{{ "common_remove" | translate }}</span>
					</button>
				}
				@if (shouldShowDownloadButton(collectionItem)) {
					<button
						mat-menu-item
						data-cy="download-library-item"
						class="download-option"
						(click)="downloadItem(collectionItem)"
						>
						<span>{{ "common_download" | translate }}</span>
					</button>
				}
				@if (canRestore(collectionItem)) {
					<button
						mat-menu-item
						class="restore-option"
						(click)="moveItem(collectionItem)"
						>
						<span>{{ "common_restore" | translate }}</span>
					</button>
				}
				@if (!UADetect.isMobile() && itemInUse) {
					<button
						mat-menu-item
						class="download-report-option"
						(click)="downloadReport(collectionItem)"
						>
						<span>{{ "library-collections_download-report" | translate }}</span>
					</button>
				}
			} @else {
				<div class="loading-items">
					<i class="ficon-spinner ficon-spin"></i>
				</div>
			}
		</mat-menu>
	}
